import { ErroFlagsmith } from './flagsmith.excecoes';
import { FUNCIONALIDADES, IFuncionalidadesDoSistema, FUNCIONALIDADES_VALORES_PADRAO, IModulosDoSistema, MODULOS, MODULOS_VALORES_PADRAO } from 'src/core/modulos'
import { Store } from 'vuex';
import { observabilidadeLegada } from '@/integracoes/src-next/observabilidade'
import flagsmith from 'flagsmith';
import { obterSecret } from 'src/typescript/servicos/bifrost/bifrost.servico'
import { useAcessoStore } from '@next/compartilhados/acesso'
import { pinia } from 'src/pinia'

class ServicoFlagSmith {
  store: Store<unknown>;
  constructor (store: Store<unknown>) {
    this.store = store
  }

  private async inicializar (idEmpresaUsuario: string, _nomeEmpresaUsuario: string): Promise<void> {
    flagsmith.init({
      api: process.env.VUE_APP_FLAGSMITH_URL,
      environmentID: obterSecret('FLAGSMITH_API_KEY'),
      cacheFlags: true,
      evaluationContext: {
        identity: {
          identifier: idEmpresaUsuario,
        },
      },
      enableAnalytics: true,
      onChange: () => {
        this.atribuirModulosParaAplicacao();
        this.atribuirFuncionalidadesParaAplicacao();
      },
      onError: (erro) => {
        observabilidadeLegada.registrarErro(new ErroFlagsmith(erro.message), {
          origem: 'flagsmith', operacao: 'inicializacao', categoria: 'qualidade',
        })
        return
       }
    }).catch(() => {})
  }

  async obterAtributosDoUsuario () {
    try {
      const atributos = flagsmith.getAllTraits()
      const modulos = Object.values(MODULOS) as IModulosDoSistema[]
      const modulosRecuperadosFlagsmith = {} as Record<IModulosDoSistema, unknown>

      for (const modulo of modulos) {
        modulosRecuperadosFlagsmith[modulo] = atributos[modulo] ?? MODULOS_VALORES_PADRAO[modulo]
      }
      return modulosRecuperadosFlagsmith
    } catch {
      observabilidadeLegada.registrarErro(new ErroFlagsmith('Erro ao obter atributos do usuário'), {
        origem: 'flagsmith', operacao: 'modulos', categoria: 'qualidade'
      })
      return MODULOS_VALORES_PADRAO
    }
  }

  async obterFuncionalidadesDoUsuario () {
    try {
      const funcionalidades = flagsmith.getAllFlags()
      const funcionalidadesDoSistema = Object.values(FUNCIONALIDADES) as IFuncionalidadesDoSistema[]
      const funcionalidadesRecuperadasFlagsmith = {} as Record<IFuncionalidadesDoSistema, unknown>

      for (const funcionalidade of funcionalidadesDoSistema) {
        funcionalidadesRecuperadasFlagsmith[funcionalidade] = funcionalidades[funcionalidade] ?? FUNCIONALIDADES_VALORES_PADRAO[funcionalidade]
      }

      return funcionalidadesRecuperadasFlagsmith
    } catch {
      observabilidadeLegada.registrarErro(new ErroFlagsmith('Erro ao obter funcionalidades do usuário'), {
        origem: 'flagsmith', operacao: 'funcionalidades', categoria: 'qualidade'
      })
      return FUNCIONALIDADES_VALORES_PADRAO
    }
  }

  async atribuirFuncionalidadesParaAplicacao () {
    const funcionalidades = await this.obterFuncionalidadesDoUsuario()
    if (funcionalidades) {
      this.store.commit('DEFINIR_FUNCIONALIDADES', funcionalidades)
      useAcessoStore(pinia).mapearFuncionalidades(funcionalidades as Record<string, { enabled: boolean, value?: unknown }>)
    }
  }

  async atribuirModulosParaAplicacao () {
    const modulos = await this.obterAtributosDoUsuario()
    if (modulos) {
      this.store.commit('DEFINIR_MODULOS', modulos)
      useAcessoStore(pinia).mapearModulos(modulos)
    }
  }
}

export default ServicoFlagSmith
